<template>
  <div class="row">
    <div class="medium-6 columns">
      <section>
        <h1 v-html="pageHeadline" />

        <article class="flow-group">
          <h3 v-html="claimSummaryHeadline" />
          <p v-html="claimSummaryText" />

          <table data-test-bike-claim-flow-summary-table>
            <tr v-for="(item, index) in summaryData" :key="'item-' + index">
              <td v-html="item.label" />
              <td v-html="item.value" />
            </tr>
          </table>
        </article>

        <article class="flow-group">
          <h3 v-html="scalepointHeadline" />

          <div class="control">
            <Field
              v-slot="{ field }"
              v-model="requestScalepointLink"
              name="bike-theft-claim-flow-scalepoint"
              type="checkbox"
              :value="true"
              :unchecked-value="false"
            >
              <base-single-checkbox
                v-bind="field"
                :label="requestScalepointLinkLabel"
                :disabled="loading"
                :errors="errors"
                name="bike-theft-claim-flow-scalepoint"
              />
              <ValidationError name="bike-theft-claim-flow-scalepoint" />
            </Field>
          </div>
        </article>

        <div class="row">
          <div class="columns medium-6">
            <router-link
              class="button secondary text-center"
              :to="routerLink"
              :class="{ disabled: loading }"
              data-test-bike-theft-claim-flow-link-button-back
            >
              Tilbage
            </router-link>
          </div>
          <div class="columns medium-6">
            <base-button
              type="submit"
              :disabled="loading"
              :spinner="loading"
              data-test-bike-theft-claim-flow-button-submit
            >
              {{ submitButtonText }}
            </base-button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseButton from '@/components/UI/BaseButton.vue';
import BaseSingleCheckbox from '@/components/Forms/BaseSingleCheckbox.vue';
import ValidationError from '@/components/UI/ValidationError.vue';

export default {
  name: 'Summary',
  components: { BaseButton, BaseSingleCheckbox, ValidationError },
  props: {
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  computed: {
    ...mapState({
      claimSummaryHeadline: (state) =>
        state.bikeTheftClaimFlow.data.summaryPage.claimSummaryHeadline,
      claimSummaryText: (state) => state.bikeTheftClaimFlow.data.summaryPage.claimSummaryText,
      extraBikeEquipment: (state) =>
        state.bikeTheftClaimFlow.data.submitData.bicycleClaimQuestionsTemplateModel
          .extraBikeEquipmentSelectedValue,
      loading: (state) => state.bikeTheftClaimFlow.loading,
      pageHeadline: (state) => state.bikeTheftClaimFlow.data.summaryPage.pageHeadline,
      requestScalepointLinkLabel: (state) =>
        state.bikeTheftClaimFlow.data.summaryPage.requestScalepointLinkLabel,
      scalepointHeadline: (state) => state.bikeTheftClaimFlow.data.summaryPage.scalepointHeadline,
      submitButtonText: (state) => state.bikeTheftClaimFlow.data.summaryPage.submitButtonText
    }),
    requestScalepointLink: {
      get() {
        return this.$store.state.bikeTheftClaimFlow.data.submitData
          .bicycleClaimQuestionsTemplateModel.requestScalepointLink;
      },
      set(value) {
        this.$store.commit('bikeTheftClaimFlow/setRequestScalepointLink', value);
      }
    },
    routerLink() {
      if (this.extraBikeEquipment === 'Ja') {
        return '/opret-cykel-skade/what/bike/equipment';
      }

      return '/opret-cykel-skade/what/bike';
    },
    summaryData() {
      return this.$store.getters['bikeTheftClaimFlow/summaryData'];
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';
@import 'src/styles/colors.scss';
@import 'src/styles/typography/_fonts.scss';

table {
  margin-top: rem-calc(50);

  tr {
    td {
      width: 50%;
      padding-bottom: rem-calc(10);
      vertical-align: top;

      &:first-of-type {
        font-family: $base-font-bold;
        color: $primary-color;
      }
    }
  }
}
</style>
